module.exports = __webpack_public_path__ + "static/media/taxida_white.35bf51a0.svg";